import React from 'react';

const NotificationOverlay = ({ 
    translations, 
}) => {
    return (
        <>
            {/* snackbar コピーリンク */}
            <div aria-live="polite">
                <p className="c-alert is-hide s-alert" data-alert-id="copy-alert">
                    <span className="s-alert_message">{translations.job_items.link_copied}</span>
                </p>
            </div>
        </>
    );
};

export default NotificationOverlay; 